import React, { useContext, useEffect, useState } from 'react'
import { useDispatch } from 'react-redux'

import { css } from 'design'
import { Button } from 'primitives/button'

import { useCallManager } from '../../contexts/call_manager_context'
import { useAxios } from '../../hooks/use_axios'
import { VideoOnIcon } from '../../images'
import { newTopic } from '../../reduxes/slices/topics/actions'
import { useSelectorDelegateStore } from '../../reduxes/stores/root_store/hooks'
import { AppLocationContext, WIDGET_VIEW } from '../admin/app_location_provider'
import { OptionsPageContainer } from './options_page_container'

export const VideoOptionsPage = () => {
  const { setAppLocation } = useContext(AppLocationContext)
  const { joinCall } = useCallManager()
  const dispatch = useDispatch()
  const axios = useAxios()
  const [topicId, setTopicId] = useState()
  const cableCar = useSelectorDelegateStore((state) => state.cablecar)

  const startCall = () => {
    dispatch(axios(newTopic({}))).then((tId: any) => {
      setTopicId(tId)
    })
  }

  useEffect(() => {
    if (topicId && cableCar.isConnected) {
      joinCall &&
        joinCall({ topicId, callType: 'video' }).catch(() => {
          // do nothing
        })
      setTopicId(undefined)
    }
  }, [cableCar.isConnected, joinCall, topicId])

  const goToVideoRecorder = () => {
    setAppLocation({
      widgetView: WIDGET_VIEW.VIDEO_RECORDER,
    })
  }

  return (
    <OptionsPageContainer heading={'Video Options'}>
      <Button onClick={startCall}>
        <div className={liveBadgeStyles()}>LIVE</div>
        Start Video Call
      </Button>
      <Button onClick={goToVideoRecorder}>
        <VideoOnIcon />
        Leave Video Message
      </Button>
    </OptionsPageContainer>
  )
}

const liveBadgeStyles = css({
  background: '#26c280',
  color: 'white',
  borderRadius: 10,
  fontSize: 10,
  padding: '2px 6px',
  position: 'absolute',
  left: 10,
})
